'use client'

import type { Session } from 'next-auth'
import { SessionProvider } from 'next-auth/react'
import { UserProvider } from './UserContext'

export default function BSSOProvider({ session, children }: { session: Session | null; children: React.ReactNode }) {
  return (
    <SessionProvider session={session}>
      <UserProvider session={session}>{children}</UserProvider>
    </SessionProvider>
  )
}
